module.exports = __webpack_public_path__ + "img/fly.75b8217d.png";